// extracted by mini-css-extract-plugin
export default {"SideMenu":"_SideMenu--knfsg","Mobile":"_Mobile--BIWmA"};